/**
 * 안드로이드에서 지원되지 않는 interface 호출 시
 * Method not found 에러가 동기적으로 발생합니다.
 */
export const isMethodNotFoundError = (e: unknown) => {
  return e instanceof Error && e.message.includes('Method not found');
};
